// extracted by mini-css-extract-plugin
export default {"root":"_1N5Hc","title":"_1wfdp","message":"_19HfI","core-star":"_3X5lU","coreStar":"_3X5lU"};